/**
 * Выбор темы.
 *
 * По умолчанию следуем системной настройке — она у человека уже выставлена под
 * его свет и время суток. Ручной выбор перебивает систему и запоминается.
 *
 * Проектор к этому отношения не имеет: страница `/present` держит тёмную
 * палитру независимо от выбора (см. `.stage` в index.css), потому что светлый
 * экран во всю стену в полумраке зала слепит.
 */
export type Theme = 'system' | 'light' | 'dark'

const KEY = 'clapme_theme'

export function readTheme(): Theme {
  try {
    const stored = localStorage.getItem(KEY)
    return stored === 'light' || stored === 'dark' ? stored : 'system'
  } catch {
    return 'system'
  }
}

export function applyTheme(theme: Theme) {
  const root = document.documentElement
  if (theme === 'system') {
    root.removeAttribute('data-theme')
  } else {
    root.setAttribute('data-theme', theme)
  }

  try {
    if (theme === 'system') localStorage.removeItem(KEY)
    else localStorage.setItem(KEY, theme)
  } catch {
    /* приватный режим — тема просто не запомнится */
  }
}

/** Что показывается сейчас, с учётом системной настройки. */
export function effectiveTheme(theme: Theme): 'light' | 'dark' {
  if (theme !== 'system') return theme
  return window.matchMedia?.('(prefers-color-scheme: light)').matches ? 'light' : 'dark'
}

/** Следующее значение по кругу: система → светлая → тёмная → система. */
export function nextTheme(theme: Theme): Theme {
  return theme === 'system' ? 'light' : theme === 'light' ? 'dark' : 'system'
}

export const THEME_LABEL: Record<Theme, string> = {
  system: 'как в системе',
  light: 'светлая',
  dark: 'тёмная',
}
